function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  let formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    let parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function setMiniBagDrawerHeight() {
  const header = document.querySelector('.mini-bag-header');
  const items = document.querySelector('.min-bag-items');
  const footer = document.querySelector('.mini-bag-footer');

  const headerRect = header.getBoundingClientRect();
  const footerRect = footer.getBoundingClientRect();

  const height = window.innerHeight - (headerRect.height + footerRect.height);

  items.style = `height: ${height - 16}px !important`;
}

async function initializeCart() {
  setMiniBagDrawerHeight();

  document.querySelectorAll('.quantity-selector button').forEach((button) => {
    button.onclick = function (e) {
      e.preventDefault();
      const currentQty = button.parentElement.querySelector('input');
      const qty = Number(currentQty.value);
      const isPlus = button.classList.contains('plus');
      const cartItem = button.closest('.cart-item');
      const key = cartItem.getAttribute('data-key');
      const max = cartItem.getAttribute('data-max-qty');
      const isMiniBag = cartItem.getAttribute('data-mini-bag');
      const qtyErr = cartItem.querySelectorAll('.qty-error');
      const undoBtn = cartItem.querySelector('.undo-btn');
      let newQty = 0;
      if (qtyErr.length) {
        qtyErr.forEach((err) => {
          err.innerText = '';
        });
      }

      currentQty.classList.remove('text-brand-red');
      if (isPlus) {
        newQty = qty + 1;
        if (max >= newQty) {
          currentQty.value = newQty;
          updateItem(key, newQty, cartItem);
        } else if (qtyErr.length) {
          qtyErr.forEach((err) => {
            err.innerText = 'Only ' + max + ' left in stock';
          });
          button.setAttribute('disabled', true);
          currentQty.classList.add('text-brand-red');
        }
      } else {
        newQty = qty - 1;
        if (newQty < 1) {
          newQty = 0;
          const key = cartItem.getAttribute('data-key');
          if (isMiniBag) {
            if (undoBtn) undoBtn.setAttribute('data-is-clicked', false);
            undoItem(cartItem);
            removeItemState(key, cartItem);
          } else {
            updateItem(key, newQty, cartItem);
          }
        } else if (max >= newQty) {
          currentQty.value = newQty;
          updateItem(key, newQty, cartItem);
        }
      }
    };
  });

  document.querySelectorAll('.remove-item-cart-page').forEach((remove) => {
    const oldBtn = remove;
    const newBtn = oldBtn.cloneNode(true);
    oldBtn.parentNode.replaceChild(newBtn, oldBtn);

    newBtn.addEventListener('click', (event) => {
      document.dispatchEvent(new CustomEvent('initLoader'));
      event.preventDefault();
      const htmlItem = newBtn.closest('.cart-item');
      const key = htmlItem.getAttribute('data-key');
      updateItem(key, 0, htmlItem);
    });
  });

  document.querySelectorAll('.remove-item').forEach((remove) => {
    remove.addEventListener('click', (e) => {
      e.preventDefault();
      const htmlItem = remove.closest('.cart-item');
      const undoBtn = htmlItem.querySelector('.undo-btn');
      if (undoBtn) undoBtn.setAttribute('data-is-clicked', false);
      const isMiniBag = htmlItem.getAttribute('data-mini-bag');
      const key = htmlItem.getAttribute('data-key');
      if (isMiniBag) {
        const isDeleting = htmlItem.getAttribute('data-is-deleting');
        if (isDeleting == 'false') {
          htmlItem.setAttribute('data-is-deleting', true);
          undoItem(htmlItem);
          removeItemState(key, htmlItem);
        }
      } else {
        updateItem(key, 0, htmlItem);
      }
    });
  });

  document.querySelectorAll('.undo-btn').forEach((undo) => {
    undo.addEventListener('click', (e) => {
      e.preventDefault();
      undo.setAttribute('data-is-clicked', true);
      const htmlItem = undo.closest('.cart-item');
      undoItem(htmlItem, true);
    });
  });

  const count = await getCount();
  updateBadges(count);

  const hasOnlyFreeSamples = await checkAndRemoveFreeSamples();
  if (hasOnlyFreeSamples) {
    updateCart();
  }
  checkDiscountSummary();
}

function updateItem(key, quantity, htmlItem) {
  blockCheckoutButtons();
  if (quantity === 0) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then(async (res) => {
        const onlyNonProducts = hasOnlyNonProducts(res);
        const count = await getCount();
        updateBadges(count);
        updateMoneyFormat(res, quantity);
        if (onlyNonProducts) {
          await updateNonProducts(res);
        }
        updateCart(onlyNonProducts, quantity, htmlItem);
        updateProgressBars(res.total_price);
      });
  }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: key,
      quantity: quantity,
    }),
  })
    .then((response) => response.json())
    .then(async (res) => {
      const count = await getCount();
      updateBadges(count);
      updateCart();
      updateNonProducts(res);
      updateMoneyFormat(res);

      if (!quantity) htmlItem.remove();

      // Dispatch custom event
      document.dispatchEvent(new CustomEvent('cartUpdated'));
      updateProgressBars(res.total_price);

      document.querySelector('.sign-in-drawer').classList.remove('hidden', 'menu-opened');

      // Check and remove free samples if necessary
      const hasOnlyFreeSamples = await checkAndRemoveFreeSamples();
      if (hasOnlyFreeSamples) {
        document.dispatchEvent(new CustomEvent('clearCartPage'));
        updateCart();
      }
    });
}

async function updateCart(hasOnlyNonProducts = false, quantity, htmlItem) {
  await updateItemInformationContainer();
  updateItemDom(quantity, htmlItem);
  if (!hasOnlyNonProducts) {
    await updateWrappingOptions();
    await updateSamples();
  }

  document.dispatchEvent(new CustomEvent('cartUpdated'));
  document.dispatchEvent(new CustomEvent('wrappingOptionsUpdated'));
  document.dispatchEvent(new CustomEvent('reUpdateImageSrc'));

  document.querySelector('.sign-in-drawer').classList.remove('hidden', 'menu-opened');

  // Check and remove free samples if necessary
  const hasOnlyFreeSamples = await checkAndRemoveFreeSamples();
  if (hasOnlyFreeSamples) {
    document.dispatchEvent(new CustomEvent('clearCartPage'));
    updateCart();
  }
}

function updateItemDom(quantity, htmlItem) {
  if (quantity === 0) {
    // Remove the item from the DOM
    htmlItem.remove();
  }
}

function checkIfOnlyGiftCardInCart(items) {
  const checkproductArrays = (items) => {
    const filteredOutGiftCardProducts = items.filter((item) => {
      return item.product_type === 'gift' || item.product_type === 'experience' || item.price === 0 || item.product_type === 'packaging';
    });
    const remaining = items.filter(
      (item) => !filteredOutGiftCardProducts.some((filteredItem) => filteredItem === item)
    );
    if (remaining.length !== 0) {
      return false;
    }
    return true;
  };
  const onlyGiftCardsInCart = checkproductArrays(items);
  if (!onlyGiftCardsInCart) {
    return false;
  }
  
  document.dispatchEvent(new CustomEvent('clearCartPage'));
  return true;
}

async function checkAndRemoveFreeSamples() {
  const updatedItems = await updateCount();
  const nonFreeSampleItems = updatedItems.filter((item) => item.price !== 0);
  const freeSampleItems = updatedItems.filter((item) => item.price === 0 || item.product_type === 'packaging');
  const onlyGiftCardsInCart = checkIfOnlyGiftCardInCart(updatedItems);

  if ((nonFreeSampleItems.length === 0 || onlyGiftCardsInCart === true) && freeSampleItems.length > 0) {
    for (const item of freeSampleItems) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0,
        }),
      });
    }
    return true;
  }
  return false;
}

function updateProgressBars(cartTotalPrice) {
  const freeshippingAmounts = document.querySelectorAll('.freeshipping-amount');
  const progressBars = document.querySelectorAll('.progress-bar');
  const shippingNotices = document.querySelectorAll('.shipping-notice');
  const moneyFormat = document.querySelector('[data-money-format]');

  const moneyFormatted = document.querySelector('[data-money-format]');

  const currencyFormatted = moneyFormatted.getAttribute('data-money-format');

  freeshippingAmounts.forEach((amountElement, index) => {
    const freeshippingPrice = parseInt(amountElement.textContent);
    const progressBar = progressBars[index];
    const shippingNotice = shippingNotices[index];

    progressBar.value = cartTotalPrice;

    if (cartTotalPrice >= freeshippingPrice) {
      if (shippingNotice) {
        shippingNotice.textContent = "Congratulations! You've got complimentary delivery";
      }
    } else {
      if (shippingNotice) {
        const remainingAmount = freeshippingPrice - cartTotalPrice;
        shippingNotice.textContent =
          'Spend ' + formatMoney(remainingAmount, currencyFormatted) + ' more to get FREE shipping.';
      }
    }
  });
}

function removeItemState(key, item) {
  setTimeout(function () {
    const isClicked = item.querySelector('.undo-btn');
    const undo = isClicked ? isClicked.getAttribute('data-is-clicked') : 'false';
    if (undo == 'false') {
      updateItem(key, 0, item);
    }
  }, 1000);
}

function updateBadges(count) {
  const badges = document.querySelectorAll('.mini-bag-icon .badge-inverted');

  badges.forEach((badge) => {
    badge.classList.toggle('hidden', count === 0);
    if (count > 0) {
      badge.innerText = count;
    }
  });
}

async function updateWrappingOptions() {
  const wrappingOptionsResponse = await fetch(`${Shopify.routes.root}cart?view=alt`);
  const wrappingOptionsHtml = await wrappingOptionsResponse.text();

  const parser = new DOMParser();
  const doc = parser.parseFromString(wrappingOptionsHtml, 'text/html');

  const newWrappingOptions = doc.querySelector('.wrapping-options');
  const currentWrappingOptions = document.querySelector('.wrapping-options');

  if (!currentWrappingOptions || !newWrappingOptions) return false;

  currentWrappingOptions.replaceWith(newWrappingOptions);
  document.dispatchEvent(new CustomEvent('wrappingOptionsUpdated'));
  return true;
}

async function updateSamples() {
  const freeSamplesResponse = await fetch(`${Shopify.routes.root}cart?view=alt`);
  const freeSamplesHtml = await freeSamplesResponse.text();

  const parser = new DOMParser();
  const doc = parser.parseFromString(freeSamplesHtml, 'text/html');

  const newFreeSamples = doc.querySelector('.free-samples');
  const currentFreeSamples = document.querySelector('.free-samples');
  const newFreeSamplesMobile = doc.querySelector('.free-samples-mobile');
  const currentFreeSamplesMobile = document.querySelector('.free-samples-mobile');

  if (!currentFreeSamples || !newFreeSamples) return false;

  currentFreeSamples.replaceWith(newFreeSamples);
  currentFreeSamplesMobile.replaceWith(newFreeSamplesMobile);
  return true;
}

async function updateMiniCartContainer() {
  return fetch(`${Shopify.routes.root}cart?view=alt`)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newItems = doc.querySelector('.min-bag-drawer');

      const currentItems = document.querySelector('.min-bag-drawer');

      currentItems.replaceWith(newItems);
      return html;
    });
}

async function updateItemInformationContainer() {
  return fetch(`${Shopify.routes.root}cart?view=alt`)
    .then((response) => response.text())
    .then(async (html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newItems = doc.querySelector('.cart-items-container');
      const newInfo = doc.querySelector('.cart-summary-container');
      const newWrapper = doc.querySelector('.cart-wrapper-container');

      const currentItems = document.querySelector('.cart-items-container');
      const currentInfo = document.querySelector('.cart-summary-container');
      const currentWrapper = document.querySelector('.cart-wrapper-container');

      if (currentInfo) currentInfo.replaceWith(newInfo);
      if (currentItems) currentItems.replaceWith(newItems);
      if (currentWrapper) currentWrapper.replaceWith(newWrapper);

      const count = await getCount(newItems);

      if (count === 0) document.dispatchEvent(new CustomEvent('clearCartPage'));

      updateBadges(count);
    });
}

async function updateCount() {
  const response = await fetch(`${Shopify.routes.root}cart?view=alt`);
  const html = await response.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const cart = doc.querySelector('.layout-cart-json');
  const json = JSON.parse(cart?.textContent);

  if (!cart || !json) return [];
  return json?.items;
}

async function getCount() {
  const updatedItems = await updateCount();
  let counter = 0;

  if (!updatedItems) return -1;

  const items = updatedItems;
  if (items && items.length > 0) {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (
        item.properties &&
        (item?.properties?.item_type === 'free-sample' || item?.properties?.item_type === 'packaging-options')
      )
        continue;
      else counter += item.quantity;
    }
  }
  return counter;
}

async function replaceCart() {
  fetch(`${Shopify.routes.root}cart?view=alt`)
    .then((response) => response.text())
    .then((html) => {
      const element = document.createElement('div');
      element.innerHTML = html;
      document.querySelector('.cart').innerHTML = element.querySelector('.cart').innerHTML;
    });
}

function updateNonProducts(res) {
  const nonFreeSampleItems = res?.items?.filter((item) => item.price !== 0);
  const freeSampleItems = res?.items?.filter((item) => item.price === 0);

  if (nonFreeSampleItems.length === 0 && freeSampleItems.length > 0) {
    document.dispatchEvent(new CustomEvent('initLoader'));

    freeSampleItems.forEach(async (item) => {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0,
        }),
      }).then(async () => {
        updateCart();
      });
    });
  }
  return Promise.resolve(() => ({}));
}

function updateMoneyFormat(res, quantity) {
  const moneyFormat = document.querySelector('[data-money-format]');
  if (moneyFormat) {
    const currencyFormat = moneyFormat.getAttribute('data-money-format');
    const subtotal = document.querySelector('.subtotal');
    const finalPrice = document.querySelector('.final-price');
    const emptyCart = document.querySelector('.empty-cart');
    const miniBagItem = document.querySelector('.min-bag-items');
    const cartButton = document.querySelector('.cart-button');
    const miniCartCustomContent = document.querySelector('.cart-custom-content');
    const cartItemDesktop = document.querySelector('.cart-item-desktop');
    const cartItemMobile = document.querySelector('.cart-item-mobile');
    const cartItemHeading = document.querySelector('.cart-items-heading');
    const checkoutBtn = document.querySelector('.checkout-btn');
    const deviceWidth = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (res.item_count) {
      if (quantity) {
        const item = res.items.find((item) => item.key === key);
        const itemPrice = item.final_line_price;
        document.querySelectorAll(`[data-key="${key}"] .line-item-price`).forEach((linePrice) => {
          linePrice.textContent = formatMoney(itemPrice, currencyFormat);
        });
      }

      if (subtotal) subtotal.textContent = formatMoney(res.items_subtotal_price, currencyFormat);
      if (finalPrice) finalPrice.textContent = formatMoney(res.total_price, currencyFormat);
      if (miniBagItem) miniBagItem.classList.add('overflow-y-auto', 'h-4/6');
      if (cartButton) cartButton.classList.remove('hidden');
      if (emptyCart) emptyCart.classList.add('hidden');
      if (cartItemHeading) cartItemHeading.classList.remove('hidden');
      if (miniCartCustomContent) miniCartCustomContent.classList.add('hidden');
      if (checkoutBtn) checkoutBtn.classList.remove('hidden');
      if (deviceWidth > 768 && cartItemDesktop) {
        cartItemDesktop.classList.remove('hidden');
      } else if (cartItemMobile) {
        cartItemMobile.classList.remove('hidden');
      }
    } else {
      if (subtotal) subtotal.textContent = formatMoney(res.items_subtotal_price, currencyFormat);
      if (finalPrice) finalPrice.textContent = formatMoney(res.total_price, currencyFormat);
      if (emptyCart) emptyCart.classList.remove('hidden');
      if (miniCartCustomContent) miniCartCustomContent.classList.remove('hidden');
      if (miniBagItem) miniBagItem.classList.remove('overflow-y-auto', 'h-4/6');
      if (cartButton) cartButton.classList.add('hidden');
      if (cartItemDesktop) cartItemDesktop.classList.add('hidden');
      if (cartItemMobile) cartItemMobile.classList.add('hidden');
      if (cartItemHeading) cartItemHeading.classList.add('hidden');
      if (checkoutBtn) checkoutBtn.classList.add('hidden');
    }
  }
}

async function hasOnlyNonProducts(res) {
  const items = res?.items;
  if (!items || items?.length === 0) return true;
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.price !== 0) return false;
  }
  return true;
}

function blockCheckoutButtons() {
  const buttons = [
    'checkout-button-summary-options',
    'checkout-button-summary-no-options',
    'checkout-button-wrapper-options',
    'checkout-button-wrapper-no-options',
  ];

  buttons.forEach((buttonID) => {
    let button = document.getElementById(buttonID);
    if (button) {
      button.classList.add('!cursor-wait');
      button.disabled = true;
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      button = newButton;
    }
  });
}

function undoItem(item, revert = false) {
  const removedTxt = item.querySelector('.removed-text');
  const undoBtn = item.querySelector('.undo-btn');
  const productOption = item.querySelector('.product-option');
  const actionBtn = item.querySelector('.action-btn');
  const qtyPrice = item.querySelector('.qty-price');
  const qtyErr = item.querySelector('.qty-error');
  const child = item.querySelector('.cart-item-child');
  const childContent = item.querySelector('.cart-item-child-content');
  const brand = item.querySelector('.cart-item-brand');
  const productName = item.querySelector('.cart-item-name');
  if (qtyErr) qtyErr.innerText = '';
  if (revert) {
    if (child) child.classList.remove('bg-grey-30');
    if (childContent) childContent.classList.remove('py-spacing-sm-md', 'pr-spacing-sm-md');
    if (productName) {
      productName.classList.remove('text-functional-small-sm', 'md:text-functional-small-md');
      productName.classList.add('text-functional-regular-sm', 'md:text-functional-regular-md');
    }
    if (brand) brand.classList.remove('hidden');
    if (removedTxt) removedTxt.classList.add('hidden');
    if (undoBtn) undoBtn.classList.add('hidden');
    if (productOption) productOption.classList.remove('hidden');
    if (actionBtn) actionBtn.classList.remove('hidden');
    if (qtyPrice) qtyPrice.classList.remove('hidden');
  } else {
    if (child) child.classList.add('bg-grey-30');
    if (childContent) childContent.classList.add('py-spacing-sm-md', 'pr-spacing-sm-md');
    if (productName) {
      productName.classList.remove('text-functional-regular-sm', 'md:text-functional-regular-md');
      productName.classList.add('text-functional-small-sm', 'md:text-functional-small-md');
    }
    if (brand) brand.classList.add('hidden');
    if (removedTxt) removedTxt.classList.remove('hidden');
    if (undoBtn) undoBtn.classList.remove('hidden');
    if (productOption) productOption.classList.add('hidden');
    if (actionBtn) actionBtn.classList.add('hidden');
    if (qtyPrice) qtyPrice.classList.add('hidden');
  }
}

function toggleLoader(show) {
  const loader = document.getElementById('loader');
  const spinner = document.getElementById('spinner');

  if (show) {
    loader.classList.remove('hidden');
    setTimeout(() => {
      spinner.classList.remove('hidden');
    }, 2000);
  } else {
    loader.classList.add('hidden');
    spinner.classList.add('hidden');
  }
}

// Initialize cart for the first time
document.addEventListener(
  'DOMContentLoaded',
  () => {
    initializeCart();
  },
  { once: true }
);

// Listen for custom event to reinitialize cart
document.addEventListener('cartUpdated', initializeCart);

document.addEventListener('initLoader', (e) => {
  toggleLoader(true);
  setTimeout(
    () => {
      toggleLoader(false);
    },
    e && e.detail && e.detail.duration ? e.detail.duration : 8200
  );
});

//Check if discount summary is in the DOM
function checkDiscountSummary(){
  const discountSummary = document.querySelector('.limoniapps-discountninja-subtotalcomment-summary-table');
  if (discountSummary) {
    document.querySelector('.min-bag-items').classList.add('pb-108');
  }
}